import get from 'lodash/get'
import has from 'lodash/has'

import * as Model from 'api/model'
import { setLayerInDrawerHidden, setLayerInDrawerVisible } from 'drawer/tabs/layers/actions'

/**
 * Set visible flag for layers if private
 */
export default function () {
  // console.debug('SetLayerInternalVisibility')

  // Check local data source detected.
  const bLocalDataSourceDetected = Model.get('app.LocalDataSourceDetected', false)
  const layerConfs = window.store.getState().layers

  // Hide layers
  for (const layerConf of Object.values(layerConfs)) {
    const { titleid } = layerConf

    // console.debug('SetLayerInternalVisibility - layer', titleid, layerConf)

    const bInternal = get(layerConf, 'localDataSource', false)
    if (!bInternal) {
      // console.debug('SetLayerInternalVisibility - not internal, skipping', titleid)

      continue // Skip layers that are not internal.
    }

    const drawerAdded = get(layerConf, 'drawer.added', false)
    if (!drawerAdded) {
      // console.debug('SetLayerInternalVisibility - not added to drawer, skipping', titleid)

      continue // Skip layers that haven't been added.
    }

    let layerGroupAuthorised = true
    const layerAuthGroups = layerConf.aws?.auth?.groups || []

    // Layer group is authorised when at least one of the user groups they belong to are present in the
    // list of authorised groups as defined in the layer config in 'aws.auth.groups'
    if (has(layerConf, 'aws.auth.groups') && layerAuthGroups.length > 0) {
      // console.debug('Auth groups defined... check against layer.', layer.titleid)

      const loggedInUserGroups = Model.get('app.auth.aws.groups', [])
      const loggedInUserGroupsLC = loggedInUserGroups.map(loggedInUserGroup => loggedInUserGroup.toLowerCase())

      const layerAuthGroupsLC = layerAuthGroups.map(layerAuthGroup => layerAuthGroup.toLowerCase())
      layerGroupAuthorised = loggedInUserGroupsLC.some(loggedInUserGroup => layerAuthGroupsLC.includes(loggedInUserGroup))
    }

    // If showInLayerControl is explicitly set to false in the raw config then never show this private layer. Else,
    // use the value of 'showInLayerControlRawConfig'
    // This was a bit of a strange request for private layers that are linked to other private layers to not be shown in the layer control.
    const bShowInLayerControl = get(layerConf, 'showInLayerControl', false)
    const bShowInLayerControlRawConfig = get(layerConf, 'showInLayerControlRawConfig', bShowInLayerControl)
    if (bLocalDataSourceDetected && layerGroupAuthorised && bShowInLayerControlRawConfig) {
      // console.debug('SetLayerInternalVisibility - Show private layer', titleid, layer.groupid)

      window.store.dispatch(setLayerInDrawerVisible(titleid)) // TODO: This needs to be batched. Create an action to batch this.
    } else {
      // console.debug('SetLayerInternalVisibility - Hide private layer', titleid, layer.groupid, bLocalDataSourceDetected, layerGroupAuthorised, bShowInLayerControlRawConfig)

      window.store.dispatch(setLayerInDrawerHidden(titleid)) // TODO: This needs to be batched. Create an action to batch this.
    }
  }
}
